// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__LYLHW","wrapper":"Checkbox_wrapper__5dhP6","input":"Checkbox_input__sMfvx","hidden":"Checkbox_hidden__K0VBu","label":"Checkbox_label__CnqtK"};